import {Outlet, Navigate} from "react-router-dom";

const PrivateRoute = () => {
  const isAuthenticated = localStorage.getItem("cob-authenticated");
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
